<div class="flex flex-col basis-full"> 
  <div class="flex flex-row display">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
    <div class="flex flex-col items-center mb-38 mt-16">
      <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
      <div class="mat-subtitle-2 fs-16 fs-600 mt-16">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
    </div>
    <mat-divider class="w-100-percent full-width-divider ml--24 mb-16"></mat-divider>
    <div class="flex items-center justify-center">
      <button class="accent report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'BUTTONS.CLOSE' | transloco }} </button>
    </div>
  </div>
</div>
  